import { useMemo } from "react";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { IAirportOption } from "src/redux/reducers/StructuresReducer";

interface ITimeDisplayProps {
  allowTimezoneControl?: boolean;
  displayTimezone?: IAirportOption;
  timeFormat?: string;
}

/**
 * Simplified TimeDisplay component so that it minimizes the amount of items to be re-rendered every second.
 * All styling should be done outside of this component so that material styles aren't rebuild when content updates.
 * @param props - [[ITimeDisplayProps]]
 */
export const TimeDisplay = (props: ITimeDisplayProps): JSX.Element => {
  const { allowTimezoneControl, displayTimezone, timeFormat = "HH:mm" } = props;

  const date = useSelector((state: IRootState) => state.heartbeat.clock);

  const clock: string = useMemo(() => {
    if (displayTimezone?.iata && allowTimezoneControl) {
      const utcOffset = moment(date).tz(displayTimezone.timezoneId).utcOffset();
      return moment(date?.valueOf()).utcOffset(utcOffset).format(timeFormat);
    } else {
      return moment(date?.valueOf()).utcOffset(0).format(timeFormat);
    }
  }, [allowTimezoneControl, displayTimezone, date]);

  return <>{clock}</>;
};
